export const DefaultSiteName = "Sales - Точка продаж"
export const TokenName = "token"
